import 'css-chunksrc/feature/page/PageMainContentOverlay.module.scss';export default {
  "root": "PageMainContentOverlay_root",
  "open": "PageMainContentOverlay_open",
  "shadow": "PageMainContentOverlay_shadow",
  "overlay": "PageMainContentOverlay_overlay"
};